/*----- Core -----*/
import React  from 'react'
import styled from 'styled-components'

/*----- Components -----*/
import SearchResult from './SearchResult'

/*----- Assets -----*/
import Logo from '../../assets/logo.svg'

/*----- Commons -----*/
import Device 		from '../../commons/Device'
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color 			from '../../commons/Color'

const StyledRenderResult = styled.section`
	box-shadow: 0 16px 32px 4px rgb(58 129 244 / 0.1);
	border-radius: 0 0 10px 10px;
	.search-results__items {
		background-color: white;
		overflow: auto;
		border: 1px solid lightgrey;
		margin-top: -8px;
		background: white;
		border-radius: 0 0 10px 10px;
		width: 100%;
		max-height: 280px;
		padding-bottom: 64px;
	}
	.search-results__bottom-bar {
		position: absolute;
    bottom: 0;
    background: white;
    width: 100%;
    height: 40px;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px -16px 32px -2px rgb(58 129 244 / 0.3);
		${ Montserrat(10, 600, Color.main) };
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 20px;
			margin-right: 8px;
		}
	}
	@media ${ Device.lg } {
		.search-results__items {
			min-width: 500px;
			border-radius: 0 10px 10px 10px;
		}
	}
`


const RenderResults = ({ data, handleOnClickProduct }) => {
	console.log(data);
		return (
			<StyledRenderResult className="search-results">
				<div className="search-results__items">
					{
						Object.keys(data).map(function(key,i) {
							let p = data[key]
							return <SearchResult key={i} product={p} onClick={()=>handleOnClickProduct(p)} />
						})
					}
				</div>
				<div className="search-results__bottom-bar">
					<img src={Logo} alt="logo" />
					Resultados
				</div>
			</StyledRenderResult>
		)
}

export default RenderResults